var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgChain(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.418 14.458l-1.73-.884a.455.455 0 01-.18-.175.5.5 0 01-.067-.25v-3.06a.49.49 0 00-.13-.334.425.425 0 00-.31-.138.425.425 0 00-.311.138.49.49 0 00-.13.334v3.045a.497.497 0 01-.068.251.451.451 0 01-.182.174l-2.783 1.445a.44.44 0 00-.137.11.477.477 0 00-.112.34.495.495 0 00.043.178.455.455 0 00.252.24c.11.042.231.035.337-.02l2.706-1.403a.827.827 0 01.767 0l1.65.858a.414.414 0 00.483-.07.503.503 0 00.124-.507.463.463 0 00-.222-.272z",
    fill: "#737C80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.409 14.563l-4.606 2.359-1.807-.932-2.063-1.05-.734-.377c.118-.193.284-.348.479-.448l1.119-.572.401-.2.523-.254.921-.472.652-.333a1.106 1.106 0 01.993 0h.016l1.062.51 2.057 1.05.508.262c.197.1.364.259.479.457z",
    fill: "#A6F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15.267v4.602c.002.235-.058.466-.172.666a1.216 1.216 0 01-.507.487L6.32 22.88H6.29a1.09 1.09 0 01-.486.109V16.92l4.606-2.358c.136.206.211.451.214.704z",
    fill: "#57ADD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.805 16.921v6.08c-.173 0-.344-.04-.5-.119L1.68 21.05a1.212 1.212 0 01-.504-.481A1.335 1.335 0 011 19.869v-4.602c0-.251.07-.497.201-.704l4.604 2.358z",
    fill: "#80DFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79 16.393h2.037l-1.018 1.494-1.02-1.494z",
    fill: "#EBFCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 14.563l-4.604 2.359-1.796-.932-2.062-1.05-.748-.377c.118-.193.284-.348.478-.448l1.12-.572.387-.2.55-.254.922-.472.651-.333a1.107 1.107 0 01.993 0h.017l1.047.51 2.057 1.05.51.262c.196.1.362.259.478.457z",
    fill: "#A6F0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.267v4.602c0 .235-.059.466-.173.666a1.216 1.216 0 01-.507.487l-3.613 1.858h-.028c-.152.073-.317.11-.484.109V16.92l4.604-2.358c.131.207.201.453.2.704z",
    fill: "#57ADD9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.198 16.921v6.08c-.174 0-.346-.04-.503-.119L14.07 21.05a1.211 1.211 0 01-.503-.481 1.335 1.335 0 01-.176-.699v-4.602c0-.251.07-.497.2-.704l4.607 2.358z",
    fill: "#80DFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.176 16.393h2.038l-1.02 1.494-1.018-1.494z",
    fill: "#EBFCFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.607 3.415l-4.606 2.35-1.81-.932-2.06-1.04-.736-.375c.119-.194.285-.349.48-.448l1.117-.572.396-.204.528-.268.924-.472.652-.33a1.106 1.106 0 01.993 0h.016l1.048.534 2.06 1.05.517.262a1.2 1.2 0 01.481.445z",
    fill: "#A6F0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.804 4.12v4.617c.001.234-.059.464-.172.665-.114.2-.277.363-.471.47l-.033.015-3.617 1.845h-.024a1.1 1.1 0 01-.487.112v-6.08l4.606-2.358c.132.21.201.46.198.714z",
    fill: "#57ADD9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.765v6.09c-.173 0-.345-.041-.502-.12L7.876 9.886a1.22 1.22 0 01-.494-.47 1.342 1.342 0 01-.183-.68V4.12c-.001-.25.068-.495.198-.702l4.604 2.347z",
    fill: "#80DFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.984 5.246h2.035l-1.017 1.495-1.018-1.495z",
    fill: "#EBFCFF"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgChain;